import React from "react";

const InProcessingIcon = ({ fill, fill1 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <g id="Group_39" data-name="Group 39" transform="translate(-924.41 -419)">
        <circle
          id="Ellipse_9"
          data-name="Ellipse 9"
          cx="8"
          cy="8"
          r="8"
          transform="translate(924.41 419)"
          fill={fill ? fill : "#ffa800"}
        />
        <path
          id="upgjf"
          d="M21.947,5.75h0a.537.537,0,0,1,.381.159l3.008,3a.54.54,0,0,1-.764.764L22.486,7.585v6.744a.54.54,0,1,1-1.079,0V7.608l-2.07,2.07a.546.546,0,0,1-.779-.764l2.93-2.927A.54.54,0,0,1,21.947,5.75Z"
          transform="translate(910.45 417.267)"
          fill={fill1 ? fill1 : "#fff"}
        />
      </g>
    </svg>
  );
};

export default InProcessingIcon;
